import { createVuetify } from 'vuetify';
import { fa } from 'vuetify/iconsets/fa-svg';
import 'vuetify/styles';

import { skIconAliases } from '@silae/composables';
import { SILAE_KIT_THEMES, SILAE_KIT_VARIABLES } from '@silae/styles';

import { edpIconAliases } from '../icons/icon-aliases';

const vuetify = createVuetify({
	theme: {
		themes: {
			light: {
				colors: { ...SILAE_KIT_THEMES.light },
				variables: { ...SILAE_KIT_VARIABLES }
			},
			dark: {
				colors: { ...SILAE_KIT_THEMES.dark },
				variables: { ...SILAE_KIT_VARIABLES }
			}
		}
	},
	icons: {
		defaultSet: 'fa',
		aliases: { ...skIconAliases, ...edpIconAliases },
		sets: {
			fa
		}
	}
});
export { vuetify };
